module.exports = __webpack_public_path__ + "img/9791189982041.607fa737.jpg";